import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PersonasClient } from '../httpClients/PersonasClient';
import { WorkspacePersonaConfig } from '../httpClients/PersonasClient/api.schema';
import { QUERY_KEYS } from './consts';

/**
 * Hook to fetch the workspace's persona-refresh dispatcher configuration.
 * Powers the Settings modal (cron schedule, refresh toggle, orgs scope, opt-out
 * logins). Admin-gated server-side; pass `enabled: false` from the call site
 * if the active user is not an admin.
 *
 * @param options - Optional TanStack Query overrides (e.g. enabled).
 * @returns TanStack Query result wrapping `WorkspacePersonaConfig`.
 */
export const usePersonasConfigQuery = (
  options: Partial<
    UseQueryOptions<WorkspacePersonaConfig, Error, WorkspacePersonaConfig>
  > = {},
) =>
  useQuery({
    queryKey: [QUERY_KEYS.PERSONAS_CONFIG],
    queryFn: () => PersonasClient.getPersonasConfig(),
    ...options,
  });
